import React from "react";
import { Link } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";

const ProductDetail = ({ imgSrc, header, pathUrl }) => {

  return (
    <div className="bg-slate-100 rounded-md h-[360px] w-[300px] mr-12 my-4 relative">
      <div className='overflow-hidden rounded-t-md'>
        <img
          className="rounded-t-md w-full h-[240px] hover:scale-110 transition-all duration-500"
          src={imgSrc} alt=""
        />
      </div>
      <div className="px-2 mt-4">
        <p className="font-bold text-md leading-6">{header}</p>
        <div className="absolute bottom-4 left-2 text-sky-500">
          <span className="text-[16px] flex items-center justify-center">
            <RightOutlined />
            <Link to={pathUrl}>
              <span>
                了解更多
              </span>
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
